export default "__VITE_ASSET__DbFhP7mZ__"